const Terms = () => (
  <div id="terms">
    <style
      dangerouslySetInnerHTML={{
        __html:
          '\nh2 {\n  margin-top:.25in;\n   margin-right:0in;\n   margin-bottom:6.0pt;\n   margin-left:0in;\n   line-height:115%;\n   page-break-after:avoid;\n   font-size:16.0pt;\n   font-family: "Exo 2";\n   color:black;\n   border:none;\n   font-weight:normal;\n}\nh4 {\n  margin-top:14.0pt;\n   margin-right:0in;\n   margin-bottom:4.0pt;\n   margin-left:0in;\n   line-height:115%;\n   page-break-after:avoid;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:#666666;\n   border:none;\n   font-weight:normal;\n}\np.MsoTitle, li.MsoTitle, div.MsoTitle {\n  margin-top:0in;\n   margin-right:0in;\n   margin-bottom:3.0pt;\n   margin-left:0in;\n   line-height:115%;\n   page-break-after:avoid;\n   font-size:26.0pt;\n   font-family: "Exo 2";\n   color:black;\n   border:none;\n}\np.Body, li.Body, div.Body {\n  mso-style-name:Body;\n   margin-top:0in;\n   margin-right:0in;\n   margin-bottom:8.0pt;\n   margin-left:0in;\n   line-height:107%;\n   font-size:11.0pt;\n   font-family: "Exo 2";\n   color:black;\n   border:none;\n}\np.Default, li.Default, div.Default {\n  mso-style-name:Default;\n   margin-top:8.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   line-height:120%;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n   border:none;\n}\nspan.Hyperlink0 {\n  mso-style-name:"Hyperlink\\.0";\n   font-family: "Exo 2";\n   color:#0563C1;\n  text-decoration:underline;\n}\nspan.None {\n  mso-style-name:None;\n}\nspan.Hyperlink1 {\n  mso-style-name:"Hyperlink\\.1";\n   text-decoration:underline;\n}\nspan.Hyperlink2 {\n  mso-style-name:"Hyperlink\\.2";\n   background:yellow;\n   text-decoration:underline;\n}\nspan.Hyperlink3 {\n  mso-style-name:"Hyperlink\\.3";\n   font-family: "Exo 2";\n   color:#0563C1;\n   text-decoration:underline;\n}\n.MsoChpDefault {\n  font-size:10.0pt;\n   border:none;\n}\n/* Page Definitions */\n@page WordSection1 {\n  size:8.5in 11.0in;\n   margin:1.0in 1.0in 1.0in 1.0in;\n}\ndiv.WordSection1 {\n  page:WordSection1;\n}\n/* List Definitions */\nol {\n  margin-bottom:0in;\n}\nul {\n  margin-bottom:0in;\n}\n',
      }}
    />

    <div className="WordSection1">
      <p
        className="MsoTitle"
        style={{
          marginTop: '24.0pt',
          textAlign: 'justify',
          lineHeight: '150%',
          pageBreakAfter: 'auto',
        }}
      >
        GIGSOCIAL TERMS OF SERVICE
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <i>
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Last updated: October 2024
            <br />
            <br />
          </span>
        </i>
        <a />
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <b>
          <span
            lang="DE"
            style={{ fontSize: '11.5pt', lineHeight: '150%', fontFamily: '"Helvetica",sans-serif' }}
          >
            THESE TERMS CONTAIN A MANDATORY ARBITRATION PROVISION THAT, AS FURTHER SET FORTH BELOW,
            REQUIRES THE USE OF ARBITRATION ON AN INDIVIDUAL BASIS TO RESOLVE DISPUTES, RATHER THAN
            JURY TRIALS OR ANY OTHER COURT PROCEEDINGS, OR CLASS ACTIONS OF ANY KIND. PLEASE REVIEW
            THE ARBITRATION AGREEMENT BELOW FOR HOW TO OPT OUT.
          </span>
        </b>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          This Terms of Service agreement (the “Agreement”) is a legal agreement between you, as a
          user (defined below) (“you”) and GigSocial Inc. (collectively “the Company,” “us,” “we,”
          or “
        </span>
        <span lang="FR" style={{ fontFamily: '"Arial",sans-serif' }}>
          our
        </span>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ”). These terms govern your access to and use of the service platform (the “Platform”)
          offered by the Company on its Website (https://www.gigsocial.com) (the “
        </span>
        <span lang="DE" style={{ fontFamily: '"Arial",sans-serif' }}>
          Site
        </span>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ”), including any content, functionality, payment processing services and other services
          offered on or through the Site. You must read and accept this Agreement before using the
          Platform. By using the Site or the Platform, or otherwise forming this contract, you agree
          to be bound by this Agreement.
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          We may revise this Agreement at any time by updating this area of the Site and Platform
          and, at our discretion, making you aware of the updated terms, or otherwise securing your
          agreement to the revised terms. Your use, or other method of legal acceptance, of the Site
          or Platform after any revisions have been posted will constitute your agreement to the
          revised Agreement and all of the revisions.
        </span>
      </p>
      <h2
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.30j0zll" />I<span lang="DE">NCORPORATED TERMS</span>
      </h2>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          Please read the Terms of Service carefully before you start to use the Site. By using the
          Site, opening an account, or by clicking to accept or agree to the Terms of Service when
          this option is made available to you, you accept and agree to be bound and abide by these
          Terms of Service and our Privacy Policy, published at{' '}
        </span>
        <span className="Hyperlink0">
          <span style={{ color: 'black' }}>
            <a href="https://www.gigsocial.com/privacy">
              <span style={{ color: 'black' }}>
                <span style={{ color: 'black' }}>https://www.gigsocial.com/privacy</span>
              </span>
              <u>
                <span
                  style={{
                    fontFamily: '"Calibri",sans-serif',
                    color: 'black',
                    textDecoration: 'none',
                  }}
                />
              </u>
            </a>
          </span>
          <a />
        </span>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          , (the “Privacy Policy”) incorporated herein by reference. If you do not want to agree to
          these Terms of Service or the Privacy Policy, you must not access or use the Site.
        </span>
      </p>
      <h2
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.1fob9te" />
        IMPORTANT NOTICES
      </h2>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          By using and/or visiting the Site or Platform, you represent that you have read,
          understand, and agree to this Agreement, including our Privacy Policy.{' '}
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          While we make reasonable efforts to ensure that the Site and Platform remain available, we
          do not (a) represent or warrant that access to, or functionality of the Site and/or
          Platform, will be error-free or uninterrupted, or without defect, or (b) we do not
          guarantee that users will be able to access or use the Site or Platform, or its features,
          at all times. We reserve the right, from time to time, to change, modify, discontinue, add
          to, or delete, temporarily or permanently, all, or any part, of the Site or the Platform,
          with or without notice. Such changes, modifications, additions, or deletions shall be
          effective immediately upon their implementation. Your use of the Site and/or Platform
          after we post such changes, modifications, additions or deletions, or other method of
          legal acceptance, constitutes your acceptance of such changes, modifications, additions or
          deletions.
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          We reserve the right, from time to time, to modify or discontinue, temporarily or
          permanently, the Site or Platform, or any part thereof, with or without notice.
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          The Site or Platform may contain typographical errors, inaccuracies, or omissions,
          including those relating to price, and may not be complete or current. We reserve the
          right to correct any such errors, inaccuracies or omissions, and to change or update
          information at any time without prior notice, even if your order has already been accepted
          or processed.
        </span>
      </p>
      <h2
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.3znysh7" />
        LICENSE
      </h2>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          As long as you are in compliance with the conditions of this Agreement, and all
          incorporated documents, we hereby grant you, during the Term (as defined herein), a
          limited, revocable, non-assignable, non-transferrable, non-sublicensable, non-exclusive
          license to access and use the Site, the Platform, and the materials therein that are
          intended to be displayed publicly. No rights not explicitly listed are granted.
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>You agree that:</span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          you will not (a) copy or distribute any part of the Site or Platform, or (b) alter or
          modify any part of the Site or Platform other than necessary to use the Site or Platform
          for their intended purposes, without our prior written authorization; (c) reverse
          engineer, disassemble, decompile, decode, or otherwise attempt to derive or gain access to
          the source code of the Platform or any part thereof; (d) remove, delete, alter, or obscure
          any trademarks or any copyright, trademark, patent, or other intellectual property or
          proprietary rights notices from the Platform, including any copy thereof; (e) rent, lease,
          lend, sell, sublicense, assign, distribute, publish, transfer, or otherwise make available
          the Platform, or any features or functionality of the Platform, to any third party for any
          reason, including by making the Platform available on a network where it is capable of
          being accessed by more than one device at any time; and{' '}
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          you will otherwise comply with this Agreement.
        </span>
      </p>
      <h2
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.2et92p0" />E<span lang="DA">LIGIBILITY</span>
      </h2>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          The Site and Platform are not directed to individuals under the age of 13. You must be 18
          years of age or older, or, if you have parental consent, 13 years of age or older to use
          the Site or Platform. In the event that we discover that a child under the age of 13 has
          provided personally identifiable information to us, we will make efforts to delete the
          child’s information in accordance with the Children’s Online Privacy Protection Act.
          Please see the Federal Trade Commission's Website (www.ftc.gov) for more information.
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          Notwithstanding the foregoing, pursuant to 47 U.S.C. Section 230(d), as amended, we hereby
          notify you that parental control protections are commercially available to assist you in
          limiting access to material that is harmful to minors. More information on the
          availability of such software can be found through publicly available sources. You may
          wish to contact your Internet Service Provider for more information.
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          Some or all of the Site or Platform may not be available to the general public. We may
          impose eligibility rules, and terms and conditions, in addition to those in this Section
          on such portions of the Site or Platform from time to time. We reserve the right to change
          or eliminate these eligibility requirements at any time in our sole discretion.
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          You are not eligible to use the Site or Platform if doing so would violate the laws or
          regulations of the U.S. or any other country, including, but not limited to, export
          controls or restrictions.
        </span>
      </p>
      <h2
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.tyjcwt" />
        DEFINITIONS
      </h2>
      <p className="Body">
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          For the purposes of this Agreement, the following words, terms and expressions shall have
          the following meaning, except as otherwise defined in this Agreement, or where the context
          explicitly requires otherwise:
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <b>
          <span style={{ fontFamily: '"Arial",sans-serif' }}>Advertiser</span>
        </b>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          : a user who requests and purchases services from Influencers on the Platform.
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <b>
          <span lang="IT" style={{ fontFamily: '"Arial",sans-serif' }}>
            GigSocial Balance
          </span>
        </b>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          : the aggregated amount of (a) your Revenue as an Influencer, (b) less refunds from
          cancelled Orders by Advertisers, (c) plus funds deposited into the Platform for your
          future use in accordance with this Agreement, and which may be withdrawn in your
          discretion, subject to the terms of this Agreement.
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <b>
          <span style={{ fontFamily: '"Arial",sans-serif' }}>Campaign:</span>
        </b>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          a series of Orders, or aggregate of Orders, for an Advertiser.
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <b>
          <span style={{ fontFamily: '"Arial",sans-serif' }}>Custom Gig:</span>
        </b>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          an exclusive proposal that an Influencer creates in response to a Brand’s specific
          requirements.
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <b>
          <span lang="IT" style={{ fontFamily: '"Arial",sans-serif' }}>
            Dispute:
          </span>
        </b>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          {' '}
          a disagreement between an Advertiser and Influencer on the Platform with respect to an
          Order.
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <b>
          <span lang="DE" style={{ fontFamily: '"Arial",sans-serif' }}>
            Gig:
          </span>
        </b>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          {' '}
          a project/deal in which Advertisers and Influencers collaborate on the Platform.
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <b>
          <span style={{ fontFamily: '"Arial",sans-serif' }}>Gig Chat: </span>
        </b>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          a module through which Advertisers and Influencers communicate with each other in
          connection with existing Gigs and Orders.
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <b>
          <span style={{ fontFamily: '"Arial",sans-serif' }}>Income:</span>
        </b>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          the money that Influencers earn from completed Orders, and which is added to GigSocial
          Balances, subject to these Terms.
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <b>
          <span lang="IT" style={{ fontFamily: '"Arial",sans-serif' }}>
            Inventory:
          </span>
        </b>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          {' '}
          the various services offered by Influencers, and posted on the Platform, at various
          prices, in different formats, and via various social media channels.
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <b>
          <span lang="DE" style={{ fontFamily: '"Arial",sans-serif' }}>
            Order:
          </span>
        </b>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          {' '}
          a formal agreement between an Advertiser and an Influencer for the services to be provided
          buy an Influencer through the Platform, in exchange for an agreed upon payment.
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <b>
          <span style={{ fontFamily: '"Arial",sans-serif' }}>Payment Services Provider(s):</span>
        </b>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          {' '}
          third party or other service providers that provide payment services to Advertisers and
          Influencers in connection with Orders, including, without limitation, collection of funds
          from Advertisers in connection with Orders, remittances to, and withdrawal of funds by
          Influencers, currency exchange services in connection with payments for Orders in local
          currencies, and the holding of funds in connection with GigSocial Balances.
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <b>
          <span style={{ fontFamily: '"Arial",sans-serif' }}>Influencer: </span>
        </b>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          a user who offers services for purchase to Advertisers on the Platform.
        </span>
      </p>
      <h2
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.3dy6vkm" />P<span lang="DE">LATFORM OVERVIEW</span>
      </h2>
      <h4>
        <a name="_headingh.1t3h5sf" />
        <i>
          <span style={{ color: 'black' }}>General</span>
        </i>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          Among other services and functionality, the Platform provides a venue that may permit
          users to act as either buyers or sellers in a marketplace for marketing, media or other
          content and related services.{' '}
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          When you are soliciting or purchasing goods or services on the Platform, you are referred
          to herein as a “Advertiser.”{' '}
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          When you are offering for sale, or selling, goods or services on the Platform, you are
          referred to herein as a “
        </span>
        <span lang="PT" style={{ fontFamily: '"Arial",sans-serif' }}>
          Influencer.
        </span>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>” </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          Only registered users who have provided may buy and sell on the Platform. Registration is
          free.
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          The Company may, from time to time, participate in the Platform as an Advertiser and/or as
          an Influencer.
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          Registered users may possess both (Influencer or Advertiser) types of accounts
          simultaneously, subject to providing required registration details for each respective
          profile.
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          Influencers may post Custom Gigs and similar offerings and communications that may lead to
          a discussion on Gig Chat and a Gig.
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          The Platform permits the formation of Orders facilitates payment for Orders between
          Advertisers and Influencers regarding an Order (“
        </span>
        <span lang="IT" style={{ fontFamily: '"Arial",sans-serif' }}>
          GigSocial Balances
        </span>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ”), subject to the terms of this Agreement.{' '}
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          Advertisers make payments in advance on the Platform to create an Order.
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          Influencers must fulfill Orders in accordance with their terms. Orders may not be
          cancelled without cause. Cancelling orders without cause will negatively affect
          Influencers’ reputation and status.
          <br />
          <br />
          <a />
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          The Company shall be granted the right to use, in all media, in perpetuity and throughout
          the universe, all published delivered works, and any derivative works Company makes from
          the delivered works, in connection with an Order for marketing and promotion purposes,
          including the right to use the name, image, likeness, and biographical, professional, and
          other identifying information of any Influencer and any other person appearing in any
          published delivered works.
        </span>

        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          <br />
          <br />
        </span>
        <a />
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          The Company shall be granted the right to use, in all media, in perpetuity and throughout
          the universe, in any of Company’s promotional materials, the name and trademarks
          associated with any Advertiser, for purposes of identifying the respective Advertiser as a
          user of Company’s Platform.{' '}
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          Users must comply with GigSocial’s Conduct Guidelines (as updated from time to time in
          Company’s sole discretion) (the “Conduct Guidelines”), which are a set of rules and
          guidelines applicable to the GigSocial community and marketplace which supplement this
          Agreement. The Conduct Guidelines are described more fully below in this Agreement.
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          A separate agreement between each Influencer and a Buyer may be required for each Order,
          and any services requested from, or offered by, such Influencer will be subject to the
          terms, conditions and privacy policies of the Influencer in addition to this Agreement. In
          the event of a conflict between this Agreement or our Privacy Policy, and the terms,
          conditions and privacy policy of an Influencer, our Agreement or Privacy Policy shall
          control.
        </span>
      </p>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.2s8eyo1" />
        <span style={{ color: 'black' }}>Orders Made on the Platform</span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          Orders must specify certain terms, including, without limitation, the fee and compensation
          to the Influencer for the Order (the “
        </span>
        <span lang="IT" style={{ fontFamily: '"Arial",sans-serif' }}>
          Creator Fee
        </span>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ”), a description of the deliverables for the Order, as well as requirements as to the
          Order’s content, deadlines, form, length, and other information the Advertiser and
          Influencer want included in the Order. When Advertisers and Influencers are ready to
          engage each other on an Order through the Platform, the parties will be entering into an
          Order with each other facilitated by the Platform.{' '}
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          To the extent of any conflict between the terms of an Order, and the terms of this
          Agreement, the terms of this Agreement shall control.
        </span>
      </p>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.17dp8vu" />
        <span style={{ color: 'black' }}>Payments</span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          Payment of all amounts due from an Advertiser to an Influencer for, or otherwise
          associated with, an Order are required to be made in accordance with the Order.{' '}
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          Upon remittance of a Fee from Advertiser to the Company, the Company will be solely
          responsible for paying, and will pay, the Influencer. Influencers agree that the Company
          shall not be responsible or liable for any amounts not received from an Advertiser.
        </span>
      </p>
      <h2
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.26in1rg" />
        INFLUENCERS
      </h2>
      <h4 style={{ textAlign: 'justify', lineHeight: '150%' }}>
        <a name="_headingh.lnxbz9" />
        <i>
          <span style={{ color: 'black' }}>General</span>
        </i>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          For each Gig an Influencer sells, and successfully completes, the Influencer’s account
          will be credited with Income of a percentage of the Creator Fee, with the Company
          deducting a percentage of the Creator Fee as a service fee, and the Advertiser paying an
          Advertiser Fee, according to the following schedule:
        </span>
      </p>
      <p
        className="Body"
        align="center"
        style={{ maxWidth: 625, margin: '10px 0', textAlign: 'center', lineHeight: '150%' }}
      >
        <img border={0} width="100%" height={172} src="/images/gigsocial-fees.png" alt="Fees" />
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          The Company has the right to change the service fee and Advertiser Fee at any time and
          without prior notice.
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          Each Gig will include a guarantee from the Influencer to the Advertiser regarding the
          number of views that each element of the respective Inventory will receive. If the Gig
          does not meet that guaranteed number of views, then Influencer will repost the Inventory
          until the guaranteed number is satisfied. The Influencer must provide proof of views by
          uploading screenshots showing the metric information associated with the respective Gig
          for the Gig to be deemed completed.The Company may, in its sole discretion, also use an
          internal or third-party service to measure Gig metrics. The Company shall bear no
          liability and is not responsible for any fraudulent, deceptive, or manipulative, or
          incorrect data presented in any Influencer screenshots; Further, the Company shall bear no
          liability and is not responsible for any inaccuracies in incorrect data presented by any
          internal or third-party services used to measure Gig metrics.
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          Payment of an Influencer’s Creator Fee will be transferred to Influencer through the
          Platform upon completion of an Order. The Platform transfers the payment to Influencers
          once an Order is completed. The Company will deduct any applicable services fees prior to
          paying out funds to an Influencer.
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span style={{ fontFamily: '"Arial",sans-serif' }}>Influencer must follow the </span>
        <span className="Hyperlink1">
          <a href="https://www.ftc.gov/sites/default/files/attachments/press-releases/ftc-publishes-final-guides-governing-endorsements-testimonials/091005revisedendorsementguides.pdf">
            <span style={{ fontFamily: '"Arial",sans-serif' }}>
              Guides Concerning the Use of Endorsements and Testimonials in Advertising
            </span>
          </a>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}> (the “</span>
        </span>
        <span className="None">
          <span lang="NL" style={{ fontFamily: '"Arial",sans-serif' }}>
            FTC Guides
          </span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            ”) from the Federal Trade Commission in providing goods or services in connection with
            an Order. The FTC Guides set forth the general principles the FTC uses to evaluate
            endorsements and testimonials, and uses examples to illustrate the application of those
            principles. The FTC Guides do not purport to cover every possible use of endorsements in
            advertising. Accordingly, whether a particular endorsement or testimonial is deceptive
            will depend on the specific circumstances of the advertisement at issue.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            If an Order is cancelled (for any reason), the funds paid will be returned to the
            Advertiser’s GigSocial Balance in accordance with this Agreement.
            <br />
            <br />
          </span>
        </span>
        <a />
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Income generated from an Order will be made available for withdrawal by an Influencer no
            earlier than seven (7) days after the Order is marked as complete.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Influencers may withdraw Income using one of the Platform’s withdrawal options.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            An Influencer will receive a rating “Rating,” is a calculated by Company based on
            reviews received from Advertisers who have used Influencer’s services.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            The Platform may temporarily disable an Influencer's ability to withdraw Income to
            prevent fraudulent or illicit activity based on (a) security issues of which Company
            becomes aware, (b) reports by Advertisers, or (c) where multiple Platform accounts are
            associated in the name of a single Influencer.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Influencers are responsible for paying any and all taxes, including any GST, VAT, or
            other taxes, which may apply to them depending on their residency or location.
            Influencers represent and warrant that they comply, and will comply at all times, with
            their obligations under the income tax laws applicable to their jurisdiction. The
            Influencer prices shown on the Platform are inclusive of all such taxes.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Appointment as Limited Payment Collection Agent: Influencers hereby appoint the Company
            as Influencers’ authorized payment collection agent solely for the purpose of accepting
            payments (via its Payment Services Provider, if applicable) from Advertisers, and
            remitting those payments to Influencers. Influencers agree that payments from
            Advertisers to the Company shall be considered the same as payments made directly to
            Influencers. An Advertiser’s payment obligations to an Influencer will be satisfied upon
            receipt of payment by the Company (or its Payment Services Provider, as applicable), and
            the Platform (via its Payment Services Provider, as applicable) will be responsible for
            remitting the payments to the Influencer in accordance with this Agreement. If the
            Company (via Payment Services Provider) does not remit payments to Influencers in
            accordance with this Agreement, Influencers will have recourse only against the Company
            and not the Advertisers. Influencers agree that the Company may include the provisions
            above in any terms of service, receipts, disclosures, or notices including, but not
            limited to, receipts provided to Advertisers, as Company deems necessary or prudent.
          </span>
        </span>
      </p>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.35nkun2" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>Gigs</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Gigs created on the Platform contain User Generated Content.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Gigs may contain pre-approved website URLs, hashtags, endorsements, testimonials, and
            other promotional content approved by Advertisers that must meet the standards of the
            FTC Act, including the FTC Guides.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Users may be removed from the Platform for violations of this Agreement, Conduct
            Guidelines, and/or FTC Guides, which may include (but are not limited to) the following:
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '1.0in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ○<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Inappropriate / Obscene / Pornographic / Discriminatory content or services,
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '1.0in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ○<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Illegal or Fraudulent content or services,
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '1.0in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ○<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Copyright Infringement, Trademark Infringement, and violation of a third party's terms
            of service reported through our Intellectual Property Claims Policy,
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '1.0in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span lang="IT" style={{ fontFamily: '"Arial",sans-serif' }}>
          ○<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span lang="IT" style={{ fontFamily: '"Arial",sans-serif' }}>
            Plagiarism,
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '1.0in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ○<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Spam/Abusive/Deceptive content or services,
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '1.0in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ○<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Misleading content or services/misinformation,
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '1.0in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ○<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Promoting the Platform and/or Orders through (a) activities prohibited by any laws,
            regulations, and/or third party terms of service, and (b) any marketing activity that
            negatively affects our relationships with Advertisers, Influencers, or our users or
            partners.
          </span>
        </span>
      </p>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.1ksv4uv" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>Withdrawing GigSocial Balances</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Users can only withdraw the amount of their GigSocial Balance that is available for
            withdrawal, subject to a <a>clearance period of seven (7) business days</a>
          </span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            {' '}
            after the completion of an Order.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            All Income is held in an account for your benefit with the Payment Services Provider.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Fees for withdrawals will be based on the withdrawal methods selected, and you
            understand that you are responsible for paying fees or charges imposed by any Payment
            Services Provider, including all applicable taxes, if any.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            To withdraw your GigSocial Balance, you must have an account with at least one of
            GigSocial's Payment Service Providers associated with your selected withdrawal
            method(s).{' '}
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Your GigSocial profile can be associated with only one Payment Service Provider account
            from each GigSocial withdrawal method. A Payment Service Provider withdrawal account can
            be associated with only one GigSocial profile.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            To withdraw your available Income, you must click on the designated Payment Service
            Provider from the Platform.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            A minimum of $100 in an Influencer’s GigSocial Balance is required for an Influencer to
            initiate a withdrawal of Income.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            All withdrawals of Income are final. We will not be able to reverse this process once it
            has begun.
          </span>
        </span>
      </p>
      <h2
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.44sinio" />
        <span className="None">A</span>
        <span className="None">
          <span lang="DE">DVERTISERS</span>
        </span>
      </h2>
      <h4 style={{ textAlign: 'justify', lineHeight: '150%' }}>
        <a name="_headingh.2jxsxqh" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>
              General
              <br />
              <br />
            </span>
          </i>
        </span>
        <a />
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            In case of a product promotion that requires a product unboxing and/or review, the
            Advertiser is solely responsible for the cost of such product and the logistics of
            delivering such product to the Influencer. Advertisers are strictly prohibited from
            requiring Influencers to purchase the reviewed product and/or paying the shipping and
            other logistics costs on or off the Platform.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Advertisers may neither request, nor impose as a condition of any Order, that
            Influencers purchase or give anything of value in exchange for any products or services
            in connection with an Order.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            If an Advertiser chooses to send Influencers any product or service in connection with
            an Order, such products or services must be provided to the Influencers free of charge.{' '}
          </span>
        </span>
      </p>
      <h4 style={{ textAlign: 'justify', lineHeight: '150%' }}>
        <a name="_headingh.z337ya" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>Purchasing</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Purchases on the Platform can be made by using either <a>Debit Card or PayPal</a>
          </span>
        </span>

        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>.</span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Advertisers will not ask Influencers to pay, or to make payment, using any method other
            than through the Platform or Site. If an Advertiser has been asked to use an alternative
            payment method, please report it immediately to Customer Support at
          </span>
        </span>
        <a>
          <span className="None">
            <span lang="IT" style={{ fontFamily: '"Arial",sans-serif' }}>
              support@gigsocial.com.
            </span>
          </span>
        </a>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            To protect against fraud, unauthorized transactions (such as money laundering), claims
            or other liabilities, payment information in connection with withdrawals is collected by
            either the Company or Payment Services Providers. Payment Services Providers may also
            collect other information to process withdrawal payments. The Company cannot access
            payment information provided to Payment Services Providers, which is subject to the
            Payment Service Provider’s privacy policy. Please see our Privacy Policy for more
            information{' '}
          </span>
        </span>
        <span className="Hyperlink2">
          <a href="https://www.gigsocial.com/privacy">
            <span style={{ fontFamily: '"Arial",sans-serif' }}>here</span>
            <span style={{ textDecoration: 'none' }} />
          </a>
        </span>
        <a />
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>.</span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            By using any payment method, and/or providing payment details for making purchases, on
            the Platform, you represent and warrant that:{' '}
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '1.0in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ○<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            you are legally authorized to provide such information;{' '}
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '1.0in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ○<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            you are legally authorized, or have permission, to make payments using the payment
            method(s);
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '1.0in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ○<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            if you are an employee or agent of a company or person that owns the payment method, you
            are authorized by that company or person to use the payment method to make payments on
            the Platform.
          </span>
        </span>
      </p>
      <h4 style={{ textAlign: 'justify', lineHeight: '150%' }}>
        <a name="_headingh.3j2qqm3" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>Taxes</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Advertisers must comply with all tax requirements applicable to them, including, but not
            limited to, any obligation to deduct or withhold taxes. All prices and fees that appear
            on the Platform or Site are the net amounts that will be paid, after deducting for any
            taxes, levy, withholding tax, and/or other deductions.
          </span>
        </span>
      </p>
      <h2
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.1y810tw" />
        <span className="None">I</span>
        <span className="None">
          <span lang="DE">NDEPENDENT CONTRACTOR</span>
        </span>
      </h2>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Influencers agree that they are providing services through the Platform and Site as
            independent contractors, and not as employees of Advertisers.{' '}
          </span>
        </span>
      </p>
      <h2
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.4i7ojhp" />
        <span className="None">GENERAL RULES OF CONDUCT</span>
      </h2>
      <h4 style={{ textAlign: 'justify', lineHeight: '150%' }}>
        <a name="_headingh.2xcytpi" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>General</span>
          </i>
        </span>
      </h4>
      <p className="Body" style={{ textAlign: 'justify', lineHeight: '150%' }}>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Our Platform was created to facilitate a friendly, professional, safe, productive and
            collaborative environment. It is important for the guests and users to adhere to this
            community spirit while utilizing the Platform and it’s functionalities, as well as while
            interacting with the other guests and users. Below are our guidelines for you conduct on
            the Platform and Site (the “Conduct Guidelines”). If you become aware of the Conduct
            Guidelines or this Agreement, please, contact our Customer Support team at{' '}
          </span>
        </span>
        <span className="Hyperlink3">
          <span style={{ color: 'black' }}>
            <a href="mailto:support@gigsocial.com">
              <span lang="IT" style={{ color: 'black' }}>
                <span style={{ color: 'black' }}>support@gigsocial.com</span>
              </span>
            </a>
          </span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            . The results of any investigation of such violation will be kept confidential and your
            privacy and identity will be protected. If a user is found to be in violation of the
            Conduct Guidelines, or any other part of this Agreement, they will be contacted
            electronically, and their account may be suspended or permanently deleted based on the
            severity of the violation.{' '}
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Our Platform is open to everyone. Discrimination against another user/guest based on
            gender, race, nationality, age, religious affiliation, sexual preference or otherwise is
            not acceptable and may result in the suspension/deletion of your account.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            There are no guarantees of any specific level of service provided to Advertisers by
            Influencers. Our Resolution Center will help settle disputes between Advertisers and
            Influencers, if possible.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Rude, abusive, improper language, or violent messages will not be tolerated and may
            result in suspension/removal of your account.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Users who interact outside of the Platform do so at their own risk.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            The Company will have up to fourteen (14) days to investigate violations of the Conduct
            Guidelines.{' '}
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Users with suspended or disabled accounts will not be able to sell or buy on the
            Platform or Site.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Users must own the account on the Platform in their name. The Company may require users
            to prove such ownership from time to time.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            If a user is unable to prove ownership in an account in their name upon Company’s
            request, the relevant account will be disabled for a period of 90 days following full
            verification of ownership of the account, to Company’s reasonable satisfaction, in
            following the day of the last cleared payment received in their account.
          </span>
        </span>
      </p>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.1ci93xb" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>Site and Platform Use</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            The following rules apply to the use of the Site and Platform by all users, including
            Advertisers and Influencers. You agree that you will not:
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            violate any applicable law or regulation in connection with your use of the Site or
            Platform;
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            modify, adapt, translate, copy, reverse engineer, decompile or disassemble any portion
            of Site or the Platform;
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            interfere with or disrupt the operation of the Site or Platform;
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            attempt to probe, scan or test the vulnerability of our system or network or to breach
            security or authentication measures without proper authorization;
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            take any action that imposes, or may impose, in our sole discretion, an unreasonable or
            disproportionately large load on our infrastructure;
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            harvest or collect the email address or other contact information of other users of the
            Site or Platform;
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            scrape, parse or collect content from the Site or Platform via automated means;
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            submit, post or make available false, incomplete or misleading information to the Site
            or Platform, or otherwise provide such information to us;
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            impersonate any other person or business; or
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif', background: 'white' }}>
            disclose, publish, or share with any third party, except to legal or professional
            advisors under an obligation of confidentiality, the details of any reporting metrics
            that may be provided by GigSocial or other non-public information associated with the
            Site or Platform, including, but not limited to, any data regarding money spent or
            received by you in connection with the Site or Platform. You agree to keep such
            information strictly confidential.
          </span>
        </span>
      </p>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.3whwml4" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>Naming Conventions and Profile Authenticity</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            As a condition to using certain aspects of the Platform, you will be required to
            register with the Company and select a password and username (“
          </span>
        </span>
        <span className="None">
          <span lang="DE" style={{ fontFamily: '"Arial",sans-serif' }}>
            User Name
          </span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            ”). You shall provide the Company with accurate, complete, and updated registration and
            contact information. You shall not select or use as a User Name a name that is:
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            the name of another person with the intent to impersonate that person;{' '}
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            subject to any rights of a person other than you without appropriate authorization; or
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            otherwise offensive, vulgar or obscene.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            The Platform reserves the right to require users to go through a verification process in
            order to use the Site (whether by using ID, phone, camera, etc.).
          </span>
        </span>
      </p>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.2bn6wsx" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>Content Violations</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            You agree not to distribute, upload, make available or otherwise publish through the
            Platform any suggestions, information, ideas, comments, questions, notes, plans,
            proposals, graphics, drawings, designs, text, information, audio, images, software,
            music, sounds, video, comments, messages or similar material (“
          </span>
        </span>
        <span className="None">
          <span lang="IT" style={{ fontFamily: '"Arial",sans-serif' }}>
            Content
          </span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>”) that:</span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            is unlawful or encourages another to engage in anything unlawful;
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            is false, misleading or fraudulent;
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            contains a virus or any other similar programs or software which may damage the
            operation of our, or another’s, computer;
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            violates the rights of any party, or infringes upon the patent, trademark, trade secret,
            copyright, or other intellectual property right of any party; or
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            is libelous, defamatory, pornographic, obscene, lewd, indecent, inappropriate, invasive
            of privacy or publicity rights, abusing, harassing, threatening, bullying or otherwise
            objectionable.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            You are not permitted to access any portion of the Platform or the Site that is not
            public.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Except for transacting Orders, you may not use the Platform or the Site for any other
            commercial purposes.
          </span>
        </span>
      </p>
      <h4 style={{ textAlign: 'justify', lineHeight: '150%' }}>
        <a name="_headingh.qsh70q" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>Plagiarizing</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Influencers represent and warrant that any Content included in their Orders is their own
            original work and does not infringe any third party rights, including, without
            limitation, copyrights, trademarks, service marks, or other intellectual property
            rights. If music or stock-footage media is incorporated in an Order, Influencers
            represent and warrant that they hold a valid license to use such music and/or footage
            and to include them in the Orders.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            The Platform will respond to clear and complete notices of alleged copyright or
            trademark infringement. Our Intellectual Property claims procedures are incorporated in
            this Agreement.
          </span>
        </span>
      </p>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.3as4poj" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>User Behavior and Privacy</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            User privacy must be respected. As the safety and security of our users is our top
            priority, any attempts to publish or send malicious content with the intent to
            compromise another user’s account or computer environment is strictly prohibited. You
            must not contact other users with offers, comments, suggestions or any other inquiries
            not directly related to their Orders.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            The Company will not tolerate bullying, harassment, and hate speech towards anyone
            whether on the Platform or Site.
          </span>
        </span>
      </p>
      <h2
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.1pxezwc" />
        <span className="None">PLATFORM AND SITE FEES</span>
      </h2>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Except as expressly set forth in this Agreement, your access and use the Platform and
            Site are currently free. However, the Company may, in the future, charge a fee for
            certain access or usage, including, but not limited to, subscription-based recurring
            charges for certain products and services. You will not be charged for any such access
            or use of the Site unless you first agree to such charges. But any failure to pay these
            charges may result in you not having access to some, or all, of the Platform or Site.
          </span>
        </span>
      </p>
      <h2
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.49x2ik5" />
        <span className="None">SUBMISSIONS AND HANDLING OF USER GENERATED CONTENT</span>
      </h2>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.2p2csry" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>General</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            The Platform is designed to permit users to (a) solicit, respond to, and perform
            engagements through the Platform, (b) to communicate and manage projects through the
            Platform, and (c) otherwise offer themselves and their services on the Platform. Users
            may also be able to present and promote themselves and their businesses through the
            Platform through the use of their brand and creative materials. Such brand and creative
            materials are referred to as the User Generated Content.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            The creators of User Generated Content understand and acknowledge that they are solely
            responsible for such Content. Further, they represent and warrant that they have the
            right, power, and authority to:{' '}
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            post their User Generated Content without violating the rights of third parties,{' '}
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            grant the licenses specified below,{' '}
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>&nbsp;</span>
        </span>
      </p>
      <p
        className="Body"
        style={{ marginBottom: '12.0pt', textAlign: 'justify', lineHeight: '150%' }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Users submitting User Generated Content further represent and warrant that they have the
            rights from any and all third parties appearing in such Content to use such third
            parties’ names, images or likenesses and any other third party-owned elements as
            necessary in and as part of their submission of the User Generated Content.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            The Company is not responsible for any User Generated Content, including any harm caused
            to you, another User, or a third party by such User Generated Content.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Creators of User Generated Content, and/or posters of User Generated Content on the
            Platform or Site hereby agree to indemnify, defend, and hold harmless the Company and
            its parent, subsidiaries, affiliates, and their respective directors, officers,
            employees, representatives, and agents (each an “Indemnified Party”) from any and all
            claims, damages, liabilities, costs, losses, and expenses (including, but not limited
            to, reasonable attorneys’ fees and all related costs and expenses) arising from or
            relating to any claim, suit, proceeding, demand, or action brought by Users or a third
            party against an Indemnified Party relating to or arising out of any User Generated
            Content posted.
          </span>
        </span>
      </p>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.147n2zr" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>Ownership of User Generated Content</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Influencers and Advertisers agree that Company may use all User Generated Content
            submitted to the Platform, and all delivered work, including but not limited to Order
            texts, photos, videos, usernames, photos, videos, and any other information, for no
            additional consideration for marketing and/or other purposes.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Company may also use any Advertiser or Influencer’s name, image, likeness, statements,
            and biographical, professional, and other identifying information (including information
            any Advertiser or Influencer provides to us and any other information that is publicly
            available), in any form, media, or technology, whether now known or hereafter developed,
            alone or as part of other works, in connection with the administration and marketing of
            the Site or Platform.
          </span>
        </span>
      </p>
      <h2
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.3o7alnk" />
        <span className="None">I</span>
        <span className="None">
          <span lang="DE">NTELLECTUAL PROPERTY</span>
        </span>
      </h2>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.23ckvvd" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>Intellectual Property Rights and Restrictions</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            All content on the Platform and Site, or otherwise made available via the Platform and
            Site, including the text, notes, graphics, photos, sounds, music, videos,
            interactivities and the like (“
          </span>
        </span>
        <span className="None">
          <span lang="IT" style={{ fontFamily: '"Arial",sans-serif' }}>
            Site Content
          </span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            ”), the trademarks, service marks and logos contained therein (“
          </span>
        </span>
        <span className="None">
          <span lang="DA" style={{ fontFamily: '"Arial",sans-serif' }}>
            Marks
          </span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            ”), the design of the Platform and Site (“Site Design”), and all software and other
            technology used to provide the Platform and Site (“Technology”), are exclusively owned
            by or licensed exclusively to the Company and/or its parent, subsidiaries, or
            affiliates. Site Content is provided to you “
          </span>
        </span>
        <span className="None">
          <span lang="DE" style={{ fontFamily: '"Arial",sans-serif' }}>
            as is
          </span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            ” for your information and personal use only and may not be used, reproduced,
            distributed, transmitted, broadcast, displayed, sold, licensed, or otherwise exploited
            for any other purposes whatsoever. We reserve all rights not expressly granted in and to
            the Platform and Site, Site Content, Marks, Site Design and Technology. Using the
            Platform and Site does not give you any ownership of or right in or to any Site Content,
            Marks, Site Design or Technology. Users have no right, and specifically agree not to do
            the following with respect to the Platform and Site or any part, component or extension
            of the Platform and Site:
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            copy, transfer, adapt, modify, distribute or reproduce it, in any manner;
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            reverse assemble, decompile, reverse engineer or otherwise attempt to derive its source
            code, underlying ideas, algorithms, structure or organization;
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            modify or create derivative works;
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            remove any copyright notice, identification or any other proprietary notices; or
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            use the Platform and Site in any manner that could damage, disable, overburden or impair
            the Platform and Site, or interfere with any other users’ utilization of the Platform
            and Site. Users also agree not to permit or authorize anyone else to do any of the
            foregoing.
          </span>
        </span>
      </p>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.ihv636" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>Third-Party Content</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            The Platform and Site may contain information and content provided by third parties. We
            have no obligation to monitor, we do not endorse, and we are not liable, for any
            third-party content. In addition, the Platform and Site may contain links to third-party
            website. The Company is not responsible for the content on any linked site or any linked
            site contained in a linked site. We do not endorse or accept any responsibility for the
            content on such third-party Site.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Neither the Platform nor the Site are endorsed by or affiliated with any social media
            platform, including but not limited to Facebook, Snap, Instagram, TikTok, or any other
            platform.
          </span>
        </span>
      </p>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.1hmsyys" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>Our Intellectual Property</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Our graphics, logos, names, designs, page headers, button icons, scripts, and service
            names are our copyrights, trademarks, trade names and/or trade dress. The “look” and
            “feel” of the Platform and Site (including color combinations, button shapes, layout,
            design and all other graphical elements) are protected by U.S. copyright and trademark
            law. All product names, names of services, trademarks and service marks (collectively, “
          </span>
        </span>
        <span className="None">
          <span lang="DA" style={{ fontFamily: '"Arial",sans-serif' }}>
            Marks
          </span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            ”) are our property or the property of their respective owners, as indicated. You may
            not use the Marks or copyrights for any purpose whatsoever other than as permitted by
            this Agreement.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            You acknowledge that (a) the software used to provide the Platform and Site, and all
            enhancements, updates, upgrades, corrections and modifications to the software, (b) all
            copyrights, patents, trade secrets, or trademarks or other intellectual property rights
            protecting or pertaining to any aspect of such software (or any enhancements,
            corrections or modifications), and (c) any and all documentation therefor, are the sole
            and exclusive property of us and/or our licensors, as the case may be. This Agreement
            does not convey title or ownership to you, but instead gives you only the limited rights
            set forth in this Agreement.
          </span>
        </span>
      </p>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.41mghml" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>Your Comments and Feedback</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            If, at our request, you send us certain specific submissions (for example contest
            entries), or without a request from us you send us creative ideas, suggestions,
            proposals, plans, or other materials, whether online, by email, by postal mail, or
            otherwise (collectively, “Feedback”), you agree that we may, at any time, without
            restriction, edit, copy, publish, distribute, translate and otherwise use, in any
            medium, any such Feedback that you forward to us. We are and shall be under no
            obligation to:{' '}
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            maintain any Feedback in confidence;
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            pay compensation for any Feedback; or
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>respond to any Feedback.</span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            We may, but have no obligation to, monitor, edit or remove content that we determine in
            our sole discretion is unlawful, offensive, threatening, libelous, defamatory, obscene
            or otherwise objectionable or violates any party’s intellectual property or this
            Agreement.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            You agree that your Feedback will not (a) violate any right of any third-party,
            including copyright, trademark, privacy, personality or other personal or proprietary
            right (b) contain libelous or otherwise unlawful, abusive or obscene material, or (c)
            contain any computer virus or other malware that could in any way affect the operation
            of the Service or any related website. You may not use a false e-mail address, pretend
            to be someone other than yourself, or otherwise mislead us or third parties as to the
            origin of any Feedback . You are solely responsible for any Feedback you make and its
            accuracy. We take no responsibility and assume no liability for any Feedback posted by
            you or any third-party.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            To the extent that you provide the Site, the Platform or the Company with any Feedback,
            you will be deemed to have granted the Company an exclusive, royalty-free, fully paid
            up, perpetual, irrevocable, worldwide ownership rights in the Feedback. The Company is
            under no obligation to use, publish or implement any Feedback it may receive from users.
          </span>
        </span>
      </p>
      <h2
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.2grqrue" />
        <span className="None">PASSWORDS AND ACCOUNTS</span>
      </h2>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.vx1227" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>Account Registration</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            If you create an account, you must provide us with complete and accurate information.
            You must promptly update such information to keep it complete and accurate. You are
            entirely responsible for maintaining the confidentiality of your password and account.
            You are entirely responsible for any and all activities that occur under your account.
            You may not use anyone else’s account at any time. We may remove or reclaim your
            username if we believe it is appropriate (such as in response to a trademark claim). You
            understand and agree that we may assume that instructions from an individual associated
            with your account are authorized by you and may be acted upon by us.{' '}
          </span>
        </span>
      </p>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.3fwokq0" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>Security of Your Account</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Always make sure that your password is kept safe and confidential. You agree to notify
            the Company immediately of any unauthorized use of your account or any other breach of
            account security. You agree that you will not bring an action against us arising out of,
            or related to, any claimed unauthorized access using your account credentials. We will
            not be liable for any loss, damages, liability, expenses or attorneys’ fees that you may
            incur as a result of someone else using your password or account, either with or without
            your knowledge, to the fullest extent permitted by applicable law. You will be liable
            for all losses, damages, liability, expenses and attorneys’ fees incurred by the Company
            or a third party arising out of, or related to, use of your account by someone else.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Notwithstanding the foregoing, if we believe that there has been an unauthorized attempt
            to access your account, we may take reasonable efforts with reasonable speed, to disable
            or lock your account, or otherwise address the situation. If you would like to report a
            breach, please contact support@gigsocial.com with the term “Unauthorized Account Use
            Notice” in the subject line.
          </span>
        </span>
      </p>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.1v1yuxt" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>Multiple Accounts</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Platform users are limited to one active account. Any additional account determined to
            be created to circumvent guidelines, promote competitive advantages, or mislead the
            Platform users will be disabled to prevent fraud and abuse, including targeted user
            harassment and abuse. Mass account creation may result in disabling all related
            accounts. Note: any violations of this Agreement and/or our Community Standards is a
            cause for suspension or permanent deletion of all accounts.
          </span>
        </span>
      </p>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.4f1mdlm" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>Account Transfer</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Your account cannot be sold or transferred.
          </span>
        </span>
      </p>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.2u6wntf" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>Inactive Influencer Accounts</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Any Influencer account that has been "inactive" for twelve months will be automatically
            deactivated from the Platform. Inactivity is defined as having no record of clicks or ad
            impressions during the previous 12-month period. Although accounts that meet these
            criteria (no clicks or impressions for twelve months) are automatically deactivated, the
            account record is not deleted. As such, an Influencer’s account can be reactivated
            should the Influencer request the Company to do so, and otherwise qualifies for
            reactivation.
          </span>
        </span>
      </p>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.19c6y18" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>No Obligation to Retain a Record of Your Account</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            The Company has no obligation to retain a record of your account or any data or
            information that you may have stored on your account, except as otherwise specified in
            this Agreement .{' '}
          </span>
        </span>
      </p>
      <h2
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.3tbugp1" />
        <span className="None">ENFORCEMENT AND TERMINATION</span>
      </h2>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>The “</span>
        </span>
        <span className="None">
          <span lang="IT" style={{ fontFamily: '"Arial",sans-serif' }}>
            Term
          </span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            ” of this Agreement will be from the date you first use the Site or Platform until
            terminated as provided herein. We reserve the right, in our sole discretion, to
            restrict, suspend, or terminate this Agreement and your access to all or any part of the
            Site, the Platform, the Content, or Site Content at any time and for any reason without
            prior notice or liability. We reserve the right to change, suspend, or discontinue all
            or any part of the Site, the Platform, the Content, or Site Content at any time without
            prior notice or liability.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            You may terminate this Agreement at any time by deleting your account through the
            functionality of the Platform.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Without limiting the foregoing or assuming additional legal obligations, we have a
            policy of terminating repeat violators of the U.S. Copyright Act. All grants of any
            rights from you to us related to Content or other materials, including but not limited
            to copyright licenses, shall survive any termination of this Agreement. Further, your
            representations, defense, and indemnification obligations will survive any termination
            of this Agreement, as will any other obligation under this Agreement which, by expressly
            survives, or by its nature ought to survive, termination of this Agreement.
          </span>
        </span>
      </p>
      <h2
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.28h4qwu" />
        <span className="None">INDEMNIFICATION</span>
      </h2>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            You agree to defend, indemnify and hold harmless, us, our, parents, subsidiaries,
            affiliates, licensees, licensors, and each of their respective officers, directors,
            employees, successors, agents, contractors and assigns (collectively, the “the Company
            Parties”), for all claims and allegations, and costs associated with such claims or
            allegations (collectively, “Claims”), arising from or in connection with (a) your use of
            the Site or Platform, (b) any Content provided or procured on or through the Site or
            Platform, including, without limitation, all claims arising out of or based upon
            infringement, misappropriation, invasion of privacy, defamation, right of publicity
            and/or any blurring, alteration, editing, morphing, distortion, illusionary effect,
            faulty reproduction, fictionalization or use in any composite form of your or any other
            person’s or entity’s name, picture, image, likeness, comments, posts, statements or
            other information; (c) any breach or alleged breach by you of this Agreement or
            applicable laws, rules, regulations or terms and conditions of Social Platforms, or (d)
            any independent agreement or interaction that you may have with a third party, including
            any partner or service provider of ours.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            If you act as an Advertiser on the Site or Platform, you further agree to defend,
            indemnify and hold the Company Parties harmless, from any claims relating to your
            failure to pay for services solicited or procured through the Site or Platform.
          </span>
        </span>
      </p>
      <h2
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.nmf14n" />
        <span className="None">D</span>
        <span className="None">
          <span lang="DE">ISCLAIMERS</span>
        </span>
      </h2>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <i>
            <span lang="IT" style={{ fontFamily: '"Arial",sans-serif' }}>
              No Endorsement.
            </span>
          </i>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            {' '}
            You understand and agree that the Site and the Platform are not involved in the
            agreements and communications between users, including Advertisers and Influencers, and
            does not refer or endorse or recommend particular Advertisers or Influencers. You also
            understand and acknowledge that the Platform does not edit, modify, filter, screen,
            monitor, endorse or guarantee Content or the content of communications between users.
            Users are responsible for investigating and verifying, to the extent they deem
            necessary, the identity and credentials of other users contacted via the Site or
            Platform. By using the Site or Platform, you agree that any legal remedy or liability
            that you seek to for the acts or omissions of other users or third parties will be
            limited to a claim against the particular user(s) or other third party(ies) who caused
            you harm, and you agree not to attempt to impose liability on, or seek any legal remedy
            from the Company with respect to such actions or omissions.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            You acknowledge that the Company is not responsible for, and has no liability for, any
            use by you of all or any part of Content or services provided by a third-party through
            the Site or Platform, or from a third-party that you met or did business with through
            the Site or Platform.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            You acknowledge that the Company is not responsible for, and has no liability for, any
            non-payment or other non-performance of an Order that you enter into through the Site or
            Platform or non-performance by a business partner, or another user that you met or
            transacted business with through the Site or Platform.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            You understand that it is your sole responsibility to perform due diligence on Content
            sourced through the Site or Platform, and on service providers or clients that you do
            business with through the Platform, and that the sole risk of any liability associated
            with your use of such Content, work performed by such providers, and the actions of such
            clients, is with you.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            The Site or Platform may include the opinions, statements and other content of third
            parties, including other users, Advertisers and Influencers. We are not responsible for
            screening, monitoring or verifying such content, including such content’s accuracy,
            reliability or compliance with laws. Any opinions, statements, or other materials made
            available by third parties through the Site or Platform are those of such third parties
            and not of the Company, including its licensors and/or other third party providers. The
            Company does not endorse any such opinions, statements, or materials.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            You acknowledge and agree that the Company has no control over, and shall have no
            liability for any damages resulting from, the use (including, without limitation,
            re-publication) or misuse by any third party of information made public through any part
            of the Site or Platform. IF YOU CHOOSE TO MAKE ANY OF YOUR PERSONALLY IDENTIFIABLE
            INFORMATION OR OTHER INFORMATION AND OR CONTENT PUBLICLY AVAILABLE THROUGH THE PLATFORM,
            YOU DO SO AT YOUR OWN RISK. IF YOU ARE OTHERWISE REQUIRED TO DISCLOSE YOUR PERSONALLY
            IDENTIFIABLE INFORMATION IN ORDER TO ENABLE THE COMPANY, AND/OR A SELLER AS APPLICABLE,
            TO DELIVER THE SERVICES REQUESTED, WHETHER THROUGH THE PLATFORM OR OTHERWISE. YOU HEREBY
            CONSENT TO THE USE AND, WHEN NECESSARY, THE TRANSFER OF YOUR PERSONALLY IDENTIFIABLE
            INFORMATION BY THE COMPANY AS NECESSARY FOR THE PROVISION OF SERVICES THROUGH THE SITE
            AND/OR PLATFORM.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            You understand that the Company cannot and does not promise, guarantee or warrant that
            files you download through the Internet will be free from viruses, worms, Trojan horses
            or other code that may be destructive. You are responsible for implementing sufficient
            safeguards for yourself. The Company does not assume any responsibility for your use of
            the Internet.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            USE OF THE SITE AND PLATFORM IS AT YOUR OWN RISK. THE SITE AND PLATFORM, AND ALL CONTENT
            THEREON, ARE PROVIDED “AS IS” AND WITHOUT ANY WARRANTIES, EXPRESS OR IMPLIED. THE
            COMPANY DISCLAIMS ALL WARRANTIES, INCLUDING ANY IMPLIED WARRANTIES OF MERCHANTABILITY,
            FITNESS FOR A PARTICULAR PURPOSE, TITLE, OR NON-INFRINGEMENT REGARDING THE SITE,
            PLATFORM, AND ALL CONTENT THEREON. THE COMPANY DOES NOT WARRANT THAT THE SITE OR
            PLATFORM WILL BE UNINTERRUPTED OR ERROR-FREE, THAT DEFECTS WILL BE CORRECTED, OR THAT
            THE SITE OR PLATFORM ARE FREE OF VIRUSES OR OTHER HARMFUL ELEMENTS. THE COMPANY DOES NOT
            WARRANT OR MAKE ANY REPRESENTATION REGARDING ANY USE OF THE CONTENT OR ITS ACCURACY.
            NEITHER THE COMPANY, NOR ANY PERSON ASSOCIATED WITH THE COMPANY, MAKES ANY WARRANTY OR
            REPRESENTATION WITH RESPECT TO THE COMPLETENESS, SECURITY, RELIABILITY, QUALITY,
            ACCURACY OR AVAILABILITY OF THE SITE OR PLATFORM.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            YOU ASSUME THE ENTIRE COST OF ANY LOSS OR DAMAGE ARISING FROM THE USE OF THE SITE,
            PLATFORM, OR THEIR CONTENT. THE COMPANY MAKES NO WARRANTY THAT YOUR USE OF THE CONTENT
            OR SITE CONTENT WILL NOT INFRINGE THE RIGHTS OF OTHERS. THE COMPANY ASSUMES NO
            RESPONSIBILITY FOR ERRORS OR OMISSIONS IN CONNECTION WITH SUCH CONTENT.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            THE FOREGOING DOES NOT AFFECT ANY WARRANTIES WHICH CANNOT BE EXCLUDED OR LIMITED UNDER
            APPLICABLE LAW.
          </span>
        </span>
      </p>
      <h2
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.37m2jsg" />
        <span className="None">LIMITATION OF LIABILITY</span>
      </h2>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT WILL THE COMPANY, ITS PARENT,
            SUBSIDIARIES, AFFILIATES, OR THEIR RESPECTIVE LICENSORS, SERVICE PROVIDERS, EMPLOYEES,
            AGENTS, OFFICERS OR DIRECTORS, BE LIABLE FOR DAMAGES OF ANY KIND, UNDER ANY LEGAL
            THEORY, ARISING OUT OF OR IN CONNECTION WITH YOUR USE, OR INABILITY TO USE, THE SITE,
            ANY WEBSITE LINKED TO IT, THE PLATFORM, ANY CONTENT ON THE SITE, PLATFORM OR SUCH OTHER
            WEBSITE, OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE SITE, PLATFORM OR SUCH OTHER
            WEBSITE, INCLUDING ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL OR PUNITIVE
            DAMAGES, INCLUDING, BUT NOT LIMITED TO, PERSONAL INJURY, PAIN AND SUFFERING, EMOTIONAL
            DISTRESS, LOSS OF REVENUE, LOSS OF PROFITS, LOSS OF BUSINESS OR ANTICIPATED SAVINGS,
            LOSS OF USE, LOSS OF GOODWILL, LOSS OF DATA, AND WHETHER CAUSED BY TORT (INCLUDING
            NEGLIGENCE), BREACH OF CONTRACT OR OTHERWISE, EVEN IF FORESEEABLE.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            IN ACCEPTING AUTHORIZATION SOLELY AS THE AUTHORIZED PAYMENT COLLECTION AGENT OF SELLER,
            THE COMPANY, ITS PARENT, SUBSIDIARIES, AND AFFILIATES ASSUME NO LIABILITY FOR ANY ACTS
            OR OMISSIONS OF SELLER.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            THE FOREGOING DOES NOT AFFECT ANY LIABILITY WHICH CANNOT BE EXCLUDED OR LIMITED UNDER
            APPLICABLE LAW.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Notwithstanding the foregoing, if a court finds that the above disclaimers are not
            enforceable, then you agree that neither we, nor any of the Company’s parent,
            subsidiaries, affiliates, or their respective licensors, service providers, employees,
            agents, officers or directors, shall be liable for (1) any damages in excess of $500.00
            or (2) any indirect, incidental, punitive, special, or consequential damages or loss of
            use, lost revenue, lost profits or data to you, or any third party, from your use of the
            Site or Platform. This limitation shall apply regardless of the basis of your claim, or
            whether or not the limited remedies provided in this Agreement fail of their essential
            purpose.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            This limitation shall not apply to any damage that we cause you, intentionally and
            knowingly, in violation of this Agreement or applicable law.
          </span>
        </span>
      </p>
      <h2
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.1mrcu09" />
        <span className="None">AUTOMATIC TRANSLATION</span>
      </h2>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            THIS SITE AND THE PLATFORM MAY CONTAIN TRANSLATIONS POWERED BY GOOGLE. GOOGLE DISCLAIMS
            ALL WARRANTIES RELATED TO THE TRANSLATIONS, EXPRESS OR IMPLIED, INCLUDING ANY WARRANTIES
            OF ACCURACY, RELIABILITY, AND ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Reasonable efforts have been made to provide an accurate translation of the Site.
            However, no automated translation is perfect, nor is it intended to replace human
            translators. Translations are provided as a service to users of the Site, and are
            provided "as is". No warranty of any kind, either expressed or implied, is made as to
            the accuracy, reliability, or correctness of any translations made from English into any
            other language. Some content (such as images, videos, Flash, etc.) may not be accurately
            translated due to the limitations of the translation software.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            The official text is the English version of the Site. Any discrepancies or differences
            created in the translation are not binding and have no legal effect for compliance or
            enforcement purposes. If any questions arise related to the accuracy of the information
            contained in the translated Site, please refer to the English version of the Site which
            is the official version.
          </span>
        </span>
      </p>
      <h2
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.111kx3o" />
        <span className="None">M</span>
        <span className="None">
          <span lang="DE">ISCELLANEOUS</span>
        </span>
      </h2>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.3l18frh" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>Disputes and Arbitration</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            This Section is referred to as the “Arbitration Agreement.” You agree that any and all
            disputes or claims that have arisen or may arise between you and the Company, whether
            relating to this Agreement (including any alleged breach thereof), the services provided
            by the Company, any advertising, any aspect of the relationship between us, or
            otherwise, shall be resolved exclusively through final and binding arbitration, rather
            than a court, in accordance with the terms of this Arbitration Agreement, except that
            you may assert individual claims in small claims court, if your claims qualify. Further,
            this Arbitration Agreement does not preclude you from bringing issues to the attention
            of federal, state, or local agencies, and such agencies can, if the law allows, seek
            relief against us on your behalf. You agree that, by entering into this Agreement, you
            and the Company are each waiving the right to a trial by jury or to participate in a
            class action. Your rights will be determined by a neutral arbitrator, not a judge or
            jury. The Federal Arbitration Act governs the interpretation and enforcement of this
            Arbitration Agreement. The laws of the State of California shall govern this Agreement,
            and shall be used in any arbitration proceeding. Any claim or dispute arising out of, or
            in connection with any third-party that you may have met through use of the Site or
            Platform, and with whom you have a separate agreement, will be resolved as provided for
            in that agreement.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Pre-Arbitration Dispute Resolution. The Company is always interested in resolving any
            disputes amicably and efficiently, and most user concerns regarding the Site or Platform
            can be resolved quickly and to the user’s satisfaction by emailing customer support at
            support@gigsocial.com. If such efforts prove unsuccessful, a party who intends to seek
            arbitration must first send to the other, by certified mail, a written Notice of Dispute
            (“Notice”). The Notice to the Company should be sent to GigSocial Inc., c/o The
            Corporation Trust Company, Corporation Trust Center, 1209 Orange Street, Wilmington, DE
            19801 (“Notice Address”). The Notice must (a) describe the nature and basis of the claim
            or dispute, and (b) set forth the specific relief sought. If the Company and you do not
            resolve the claim within sixty (60) calendar days after the Notice is received, you or
            the Company may commence an arbitration proceeding. During the arbitration, the amount
            of any settlement offer made by the Company or you shall not be disclosed to the
            arbitrator until after the arbitrator determines the amount, if any, to which you or the
            Company is entitled.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Arbitration will be conducted by a neutral arbitrator in accordance with the American
            Arbitration Association’
          </span>
        </span>
        <span className="None">
          <span lang="PT" style={{ fontFamily: '"Arial",sans-serif' }}>
            s (
          </span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            “AAA”) rules and procedures, including the AAA’s Supplementary Procedures for
            Consumer-Related Disputes (collectively, the “AAA Rules”), as modified by this
            Arbitration Agreement. For information on the AAA, please visit its website at
            http://www.adr.org. Information about the AAA Rules and fees for consumer disputes can
            be found at the AAA’s consumer arbitration page,
            http://www.adr.org/consumer_arbitration. If there is any inconsistency between the AAA
            Rules and this Arbitration Agreement, the terms of this Arbitration Agreement will
            control unless the arbitrator determines that the application of the inconsistent
            Arbitration Agreement terms would not result in a fundamentally fair arbitration. The
            arbitrator must also follow the provisions of this Agreement as a court would. All
            issues are for the arbitrator to decide, including, but not limited to, issues relating
            to the scope, enforceability, and arbitrability of this Arbitration Agreement. Although
            arbitration proceedings are usually simpler and more streamlined than trials and other
            judicial proceedings, the arbitrator can award the same damages and relief on an
            individual basis that a court can award to an individual under the Agreement and
            applicable law. Decisions by the arbitrator are enforceable in court and may be
            overturned by a court only for very limited reasons.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Unless the Company and you agree otherwise, any arbitration hearings will take place in
            a reasonably convenient location for both parties with due consideration of their
            ability to travel and other pertinent circumstances. If the parties are unable to agree
            on a location, the determination shall be made by AAA. If your claim is for $10,000 or
            less, the Company agrees that you may choose whether the arbitration will be conducted
            solely on the basis of documents submitted to the arbitrator, through a telephonic
            hearing, or by an in-person hearing as established by the AAA Rules. If your claim
            exceeds $10,000, the right to a hearing will be determined by the AAA Rules. Regardless
            of the manner in which the arbitration is conducted, the arbitrator shall issue a
            reasoned written decision sufficient to explain the essential findings and conclusions
            on which the award is based.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Payment of all filing, administration, and arbitrator fees (collectively, the
            “Arbitration Fees”) will be governed by the AAA Rules, unless otherwise provided in this
            Arbitration Agreement. If the value of the relief sought is $75,000 or less, at your
            request, you and the Company will pay equal parts of all Arbitration Fees. If the value
            of relief sought is more than $75,000 and you are able to demonstrate to the arbitrator
            that you are economically unable to pay your portion of the Arbitration Fees or if the
            arbitrator otherwise determines for any reason that you should not be required to pay
            your portion of the Arbitration Fees, the Company will pay your portion of such fees. In
            addition, if you demonstrate to the arbitrator that the costs of arbitration will be
            prohibitive as compared to the costs of litigation, the Company will pay as much of the
            Arbitration Fees as the arbitrator deems necessary to prevent the arbitration from being
            cost-prohibitive. Payment of attorneys’ fees will be governed by the AAA Rules.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            All aspects of the arbitration proceeding, and any ruling, decision, or award by the
            arbitrator, will be strictly confidential for the benefit of all parties.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            YOU AND THE COMPANY AGREE THAT WE MAY EACH BRING CLAIMS AGAINST THE OTHER ONLY ON AN
            INDIVIDUAL BASIS AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS OR
            REPRESENTATIVE ACTION OR PROCEEDING. UNLESS BOTH YOU AND THE COMPANY AGREE OTHERWISE,
            THE ARBITRATOR MAY NOT CONSOLIDATE OR JOIN MORE THAN ONE PERSON’
          </span>
        </span>
        <span className="None">
          <span lang="DE" style={{ fontFamily: '"Arial",sans-serif' }}>
            S OR PARTY
          </span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            ’S CLAIMS AND MAY NOT OTHERWISE PRESIDE OVER ANY FORM OF A CONSOLIDATED, REPRESENTATIVE,
            OR CLASS PROCEEDING. ALSO, THE ARBITRATOR MAY AWARD RELIEF (INCLUDING MONETARY,
            INJUNCTIVE, AND DECLARATORY RELIEF) ONLY IN FAVOR OF THE INDIVIDUAL PARTY SEEKING RELIEF
            AND ONLY TO THE EXTENT NECESSARY TO PROVIDE RELIEF NECESSITATED BY THAT PARTY’S
            INDIVIDUAL CLAIM(S), EXCEPT THAT YOU MAY PURSUE A CLAIM FOR AND THE ARBITRATOR MAY AWARD
            PUBLIC INJUNCTIVE RELIEF UNDER APPLICABLE LAW TO THE EXTENT REQUIRED FOR THE
            ENFORCEABILITY OF THIS PROVISION. If for any reason a claim proceeds in court rather
            than in arbitration, both you and the Company agree that parties have each waived any
            right to a jury trial.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Notwithstanding the foregoing, you agree that the Company may bring suit in court to
            enjoin infringement or other misuse of intellectual property or other proprietary
            rights.
          </span>
        </span>
      </p>

      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.3l18frh" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>Arbitration Opt-Out</span>
          </i>
        </span>
      </h4>

      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Agreeing to this arbitration is not a mandatory condition of your contractual
            relationship with the Company. If you do not want to be subject to this arbitration
            provision, you may opt out. To do so send written notice of your decision to opt out to
            GigSocial Inc. 776 Hero Ct. Las Vegas, NV 89012. The opt-out notice must state that you
            do not agree to this agreement to arbitrate and must include your name, address, phone
            number and email address(es) used to register with or use the Site or Platform. You and
            any persons for whom you are opting out as an agent on their behalf must sign the
            opt-out notice for it be effective. The required opt out must be sent within thirty (30)
            days of your first use of either the Site or the Platform, or if you are already a user
            of the Site or Platform upon initial posting of this arbitration provision, within
            thirty (30) days of the posting of this arbitration provision. Any opt-out not received
            within the applicable thirty (30) day period set forth above will not be valid. For
            existing users bound by a prior arbitration provision with the Company for which they
            did not opt out, any opt out exercised within thirty (30) days of the posting of this
            arbitration provision, shall only apply to this arbitration provision. Your existing
            arbitration provision with the Company will remain in full force and effect. Moreover,
            neither your acceptance of this Agreement nor your decision to opt out of this
            arbitration provision will affect any obligation you have to arbitrate disputes not
            specified in this arbitration provision pursuant to any other agreement you have with
            the Company.
          </span>
        </span>
      </p>

      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            To the extent arbitration does not apply,or you opt out, you agree that any dispute
            arising out of or relating to the Site and Platform, or to the Company, may only be
            brought by you in a state or federal court located in Los Angeles, CA. YOU HEREBY WAIVE
            ANY OBJECTION TO THIS VENUE AS INCONVENIENT OR INAPPROPRIATE, AND IRREVOCABLY AGREE TO
            THE VENUE FOR SUCH DISPUTES BEING LOS ANGELES, CA.
          </span>
        </span>
      </p>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.206ipza" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>Severability</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            If any provision of this Agreement is found for any reason to be unlawful, void or
            unenforceable, then that provision will be given its maximum enforceable effect, or
            shall be deemed severable from this Agreement and will not affect the validity and
            enforceability of any remaining provision.
          </span>
        </span>
      </p>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.4k668n3" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>No Partnership</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            You agree that no joint venture, partnership, employment, or agency relationship exists
            between you and us as a result of this Agreement or your use of the Site or Platform. We
            are and shall remain independent contractors.
          </span>
        </span>
      </p>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.2zbgiuw" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>Assignment</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            We may assign our rights under this Agreement, in whole or in part, to any person or
            entity at any time with or without your consent. You may not assign the Agreement
            without our prior written consent, and any unauthorized assignment by you shall be void.
          </span>
        </span>
      </p>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.1egqt2p" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>Attorneys’ Fees</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            If we bring any litigation as permitted under this Agreement, the prevailing party in
            such litigation shall be entitled to recover from the other party all the reasonable
            costs, attorneys’ fees and other expenses incurred by such prevailing party in the
            litigation.
          </span>
        </span>
      </p>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.3ygebqi" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>No Waiver</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Our failure to enforce any provision of this Agreement shall in no way be construed to
            be a present or future waiver of such provision, nor in any way affect the right of any
            party to enforce each and every such provision thereafter. The express waiver by us of
            any provision, condition or requirement of this Agreement shall not constitute a waiver
            of any future obligation to comply with such provision, condition or requirement.
          </span>
        </span>
      </p>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.2dlolyb" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>Notices and Electronic Communications</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            You hereby consent to receiving and transacting with us by electronic means. We may
            deliver notice to you by email, posting a notice on the Site or any other method we
            choose and such notice will be effective on dispatch. If you give notice to us, it will
            be effective when received and you must use the following email address:
            support@gigsocial.com.
          </span>
        </span>
      </p>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.sqyw64" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>Equitable Remedies</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            You hereby agree that we would be irreparably damaged if the terms of this Agreement
            were not specifically enforced, and therefore you agree that we shall be entitled,
            without bond, other security, or proof of damages, to appropriate equitable remedies
            with respect to breaches of this Agreement, in addition to such other remedies as we may
            otherwise have available to us under applicable laws.
          </span>
        </span>
      </p>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.3cqmetx" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>Entire Agreement</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            This Agreement, including the documents expressly incorporated by reference, constitutes
            the entire agreement between you and us with respect to the Site and Platform, and
            supersedes all prior or contemporaneous communications, whether electronic, oral or
            written, concerning the Site or Platform.
          </span>
        </span>
      </p>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.4bvk7pj" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>Use Outside the United States of America</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            The Site and the Platform are controlled and offered by the Company from the United
            States of America. The Company makes no representations that the Site and the Platform
            are appropriate for use in other locations. Those who access or use the Site and the
            Platform from other locations do so at their own risk and are responsible for compliance
            with local law. You consent to the processing in the United States of America of
            information you provide to us.
          </span>
        </span>
      </p>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.2r0uhxc" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>Force Majeure</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Under no circumstances shall the Company, its licensor or any of their affiliates be
            held liable for any delay or failure in performance resulting directly or indirectly
            from an event beyond its reasonable control, including, without limitation, acts of God;
            earthquakes; fires; floods; wars; civil or military disturbances; acts of terrorism;
            sabotage; strikes; epidemics; pandemics; riots; power failures; computer failure and any
            such circumstances beyond its reasonable control as may cause interruption, loss or
            malfunction of utility, transportation, computer (hardware or software) or telephone
            communication service; accidents; labor disputes; acts of civil or military authority;
            governmental actions; or inability to obtain labor, material, equipment or logistics.
          </span>
        </span>
      </p>
      <h2
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.1664s55" />
        <span className="None">I</span>
        <span className="None">
          <span lang="DE">NTELLECTUAL PROPERTY CLAIMS</span>
        </span>
      </h2>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.3q5sasy" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>Copyright Policy</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            The content on our Site and the Platform includes User Generated Content (UGC). The
            Company does not check user uploaded/created User Generated Content for violations of
            copyright or other rights. The Company does, however, investigate reported violations
            and removes or disables such content shown to be violating third party rights.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            If you believe, in good faith, that any material posted on our Site or Platform
            infringes the copyright in your work, please contact our copyright agent, designated
            under the Digital Millennium Copyright Act (“DMCA”
          </span>
        </span>
        <span className="None">
          <span lang="IT" style={{ fontFamily: '"Arial",sans-serif' }}>
            ) (17 U.S.C.{' '}
          </span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            §512(c)(3)), with a copyright infringement notice (“Notice”) containing the following:
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            a physical or electronic signature of the owner, or a person authorized to act on behalf
            of the owner, of the copyright that is allegedly infringed;
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            identification of the copyrighted work claimed to have been infringed;
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            identification, with information reasonably sufficient to allow its location of the
            material that is claimed to be infringing;
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            information reasonably sufficient to permit us to contact you (including your name,
            postal address, telephone number, and, if available, email address);
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            a statement that you have a good faith belief that use of the material in the manner
            complained of is not authorized by the copyright owner, its agent, or the law; and,
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            a statement that the information in the notification is accurate, and under penalty of
            perjury, that you are authorized to act on behalf of the owner of an exclusive right
            that is allegedly infringed.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            If you believe in good faith that material you posted on our Site or Platform was
            removed, or access to such material was disabled, by mistake or misidentification,
            please contact our designated copyright agent with correspondence containing the
            following:
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            your physical or electronic signature;
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            identification of the material that has been removed or to which access has been
            disabled and the location at which the material appeared before it was removed or access
            to it disabled;
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            information reasonably sufficient to permit us to contact you (including your name,
            postal address, telephone number, and, if available, email address);
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            a statement under penalty of perjury that you have a good faith belief that the material
            identified above was removed or disabled as a result of a mistake or misidentification
            of the material to be removed or disabled; and
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            a statement that you will consent to the jurisdiction of the Federal District Court for
            the judicial district in which your address is located (or if you reside outside the
            United States, for any judicial district in which the Site or Platform may be found) and
            that you will accept service from the person (or an agent of that person) who provided
            us with the complaint at issue.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            You acknowledge that if you fail to comply with all of the requirements of this policy
            and of Section 512(c)(3) of the DMCA, your DMCA notice or counter-notice may not be
            valid. For any questions regarding this procedure, or to submit or respond to a
            complaint, please contact our designated DMCA Copyright Agent:
          </span>
        </span>
      </p>
      <p className="Body" style={{ textAlign: 'justify', lineHeight: '150%' }}>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>Copyright Agent</span>
        </span>
      </p>
      <p className="Body" style={{ textAlign: 'justify', lineHeight: '150%' }}>
        <span className="None">
          <span lang="IT" style={{ fontFamily: '"Arial",sans-serif' }}>
            GigSocial Inc.
          </span>
        </span>
      </p>
      <p className="Body" style={{ textAlign: 'justify', lineHeight: '150%' }}>
        <span className="None">
          <span lang="PT" style={{ fontFamily: '"Arial",sans-serif' }}>
            [
          </span>
        </span>
        <span className="None">
          <span lang="DE" style={{ fontFamily: '"Arial",sans-serif' }}>
            ADDRESS WHERE YOU WANT GIGSOCIAL TO RECEIVE NOTICES
          </span>
        </span>
        <span className="None">
          <span lang="PT" style={{ fontFamily: '"Arial",sans-serif' }}>
            ]
          </span>
        </span>
      </p>
      <p className="Body" style={{ textAlign: 'justify', lineHeight: '150%' }}>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>Email: </span>
        </span>
        <span className="Hyperlink3">
          <span style={{ color: 'black' }}>
            <a href="mailto:support@gigsocial.com">
              <span lang="IT" style={{ color: 'black' }}>
                <span style={{ color: 'black' }}>
                  support@gigsoci<span style={{ color: 'black' }}>al.com</span>
                </span>
              </span>
            </a>
          </span>
        </span>
      </p>
      <p className="Body" style={{ textAlign: 'justify', lineHeight: '150%' }}>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            Please be aware that if you knowingly materially misrepresent that material or activity
            on the Site or Platform is infringing your copyright, you may be held liable for damages
            (including costs and attorneys' fees) under Section 512(f) of the DMCA. Note that we
            will provide the user who is allegedly infringing your copyright with information about
            the Notice and allow them to respond. In cases where sufficient proof of infringement is
            provided, we may remove or suspend the reported materials prior to receiving the user's
            response. In cases where the allegedly infringing user provides us with a proper
            counter-notification indicating that it is permitted to post the allegedly infringing
            material, we may notify you and then replace the removed or disabled material. In all
            such cases, we will act in accordance with 17 U.S.C Section 512 and other applicable
            laws.
          </span>
        </span>
      </p>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.25b2l0r" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>
              Complaint Policy (Including Trademark and Privacy)
            </span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            If you believe in good faith that any material posted on the Site or Platform infringes
            any of your rights other than in copyright, or is otherwise unlawful, you must send a
            notice to legal@gigsocial.com containing the following information:
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            your name, physical address, e-mail address and phone number;
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            a description of the material posted on the Site that you believe violates your rights
            or is otherwise unlawful, and which parts of said materials you believe should be
            remedied or removed;
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            identification of the location of the material on the Site;
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            if you believe that the material violates your rights, a statement as to the basis of
            the rights that you claim are violated;
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            if you believe that the material is unlawful or violates the rights of others, a
            statement as to the basis of this belief;
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '0in',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            a statement under penalty of perjury that you have a good faith belief that use of the
            material in the manner complained of is not authorized and that the information you are
            providing is accurate to the best of your knowledge and in good faith; and
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '0in',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '.5in',
          textAlign: 'justify',
          textIndent: '-.25in',
          lineHeight: '150%',
        }}
      >
        <span style={{ fontFamily: '"Arial",sans-serif' }}>
          ●<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            your physical or electronic signature.
          </span>
        </span>
      </p>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            If we receive a notice that complies with all of these requirements, we will evaluate
            the submission, and if appropriate, in our sole discretion, we will take action. Note
            that we may disclose your submission to the poster of the claimed violative material, or
            any other party and allow them to respond.
          </span>
        </span>
      </p>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.kgcv8k" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>Repeat Infringers</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            It is our policy in appropriate circumstances to disable and/or terminate the accounts
            of users who are repeat infringers of intellectual property rights.
          </span>
        </span>
      </p>
      <h4
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <a name="_headingh.34g0dwd" />
        <span className="None">
          <i>
            <span style={{ color: 'black' }}>Notice to California Residents</span>
          </i>
        </span>
      </h4>
      <p
        className="Body"
        style={{
          marginTop: '12.0pt',
          marginRight: '0in',
          marginBottom: '12.0pt',
          marginLeft: '0in',
          textAlign: 'justify',
          lineHeight: '150%',
        }}
      >
        <span className="None">
          <span style={{ fontFamily: '"Arial",sans-serif' }}>
            If you are a California resident, under California Civil Code 1789.3, you may contact
            the Complaint Assistance Unit of the Division of Consumer Services of the California
            Department of Consumer Affairs in writing at 1625 N. Market Blvd., Suite S-202,
            Sacramento, California 95834, or by telephone at (800) 952-5210 in order to resolve a
            complaint regarding the Site or Platform or to receive further information regarding the
            use of the Site or Platform.
          </span>
        </span>
      </p>
    </div>
    <div>
      <hr className="msocomoff" align="left" size={1} width="33%" />
    </div>
  </div>
);

export default Terms;
